// Central data-testid registry (kebab-case, function-oriented)
export const TID = {
  nav: {
    root: "top-nav",
    logo: "nav-logo",
    home: "nav-home",
    fleet: "nav-fleet",
    bookings: "nav-bookings",
    profile: "nav-profile",
    support: "nav-support",
    login: "nav-login",
    logout: "nav-logout",
    userMenu: "nav-user-menu",
    backoffice: "nav-backoffice",
  },
  home: {
    hero: "home-hero",
    modeToggle: "home-mode-toggle",
    chauffeurBtn: "mode-chauffeur",
    rentalBtn: "mode-rental",
    ctaBrowse: "home-cta-browse",
    ctaBook: "home-cta-book",
    featuredFleet: "home-featured-fleet",
  },
  fleet: {
    grid: "fleet-grid",
    card: (id) => `fleet-card-${id}`,
    filterAvail: "filter-availability",
    filterCategory: "filter-category",
    filterCapacity: "filter-capacity",
    bookRide: (id) => `book-ride-${id}`,
    bookRental: (id) => `book-rental-${id}`,
  },
  bookRide: {
    root: "book-ride-page",
    pickup: "ride-pickup",
    dropoff: "ride-dropoff",
    datetime: "ride-datetime",
    passengers: "ride-passengers",
    hours: "ride-hours",
    notes: "ride-notes",
    submit: "ride-submit",
    total: "ride-total",
    estimate: "ride-estimate",
  },
  bookRental: {
    root: "book-rental-page",
    pickup: "rental-pickup",
    return: "rental-return",
    startAt: "rental-start",
    endAt: "rental-end",
    licenseInput: "rental-license-input",
    licenseStatus: "rental-license-status",
    accept: "rental-terms",
    submit: "rental-submit",
    total: "rental-total",
    estimate: "rental-estimate",
    // step 2 — info + DL uploads
    fullName: "rental-full-name",
    email: "rental-email",
    phone: "rental-phone",
    dlNumber: "rental-dl-number",
    dlFront: "rental-dl-front-input",
    dlBack: "rental-dl-back-input",
    dlFrontStatus: "rental-dl-front-status",
    dlBackStatus: "rental-dl-back-status",
    // step 3 — contract + signature
    contractScroll: "rental-contract-scroll",
    signaturePad: "rental-signature-pad",
    signatureClear: "rental-signature-clear",
    signatureConfirm: "rental-signature-confirm",
    // step 4 — payment method
    payCard: "rental-pay-card",
    payCash: "rental-pay-cash",
    // wizard nav
    stepNext: "rental-step-next",
    stepBack: "rental-step-back",
  },
  bookings: {
    list: "bookings-list",
    card: (id) => `booking-card-${id}`,
    payBtn: (id) => `booking-pay-${id}`,
    cancelBtn: (id) => `booking-cancel-${id}`,
    detail: (id) => `booking-detail-${id}`,
  },
  auth: {
    loginBtn: "login-btn",
    loginPage: "login-page",
    callback: "auth-callback",
  },
  profile: {
    root: "profile-page",
    phone: "profile-phone",
    save: "profile-save",
    address: "profile-address",
    addAddress: "profile-add-address",
  },
  support: {
    root: "support-page",
    name: "support-name",
    email: "support-email",
    subject: "support-subject",
    message: "support-message",
    submit: "support-submit",
  },
  payment: {
    return: "payment-return",
    status: "payment-status",
  },
};
